<div class="">
    <app-navbar-guest ></app-navbar-guest >
    <div class="content">
        <router-outlet></router-outlet>
    </div>
    <div class="content-footer">
        <footer-cmp></footer-cmp>
    </div>
</div>
    